module.exports = __webpack_public_path__ + "assets/img/hf-app-1.eb07c909.png";